import React from "react";
import {inject} from "mt-react-decorators";

@inject(['manager', 'data_section'])
export default class ToolRow extends React.Component {

    get uuid(){
        return this.props.uuid;
    }

    get manager(){
        return this.props.manager;
    }

    get section(){
        return this.props.data_section;
    }

    get initialValue(){
        return this.manager.getValue(this.uuid, this.manager.year) || 1;
    }

    getValue(input){
        const {value} = input.target;

        return parseInt(value);
    }

    componentDidMount(){
        this.manager.registerInput(this.section, this.uuid, this);
    }

    updateValue(input){
        this.manager.updateInputValue(
            this.uuid,
            {
                [this.manager.year]: this.getValue(input),
            }
        );
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__row'}>
                <div className={'mtt-sustainability-tool__row-header'}>{this.props.heading} - {this.props.text}</div>
                <div className={'mtt-sustainability-tool__row-content'}>
                    <input
                        min="1"
                        max="5"
                        type="number"
                        onChange={input => this.updateValue(input)}
                        value={this.initialValue}
                    />
                </div>
            </div>
        );
    }
}